import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate(res.user.onboarding_completed ? "/app" : "/onboarding");
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-cream-50">
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1759873821392-f04575a27eae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxzdHlsaXNoJTIwY29uZmlkZW50JTIwd29tYW4lMjBmYXNoaW9ufGVufDB8fHx8MTc3NjYzMzE5N3ww&ixlib=rb-4.1.0&q=85"
          alt="Stylish woman"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-charcoal-900/40 via-transparent to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="text-[0.65rem] tracking-[0.3em] uppercase opacity-80">Welcome back</p>
          <h2 className="font-serif text-4xl mt-3 italic">She's been waiting for you.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <Sparkle weight="fill" size={22} />
            <span className="font-serif text-2xl">Ava</span>
          </Link>
          <p className="text-[0.7rem] tracking-[0.3em] uppercase text-charcoal-500">Sign in</p>
          <h1 className="font-serif text-4xl sm:text-5xl mt-3 text-charcoal-900">Step back into your style.</h1>
          <form onSubmit={submit} className="mt-10 space-y-6">
            <div>
              <label className="text-[0.65rem] tracking-[0.25em] uppercase text-charcoal-500">Email</label>
              <input
                type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="w-full bg-transparent border-0 border-b-2 border-cream-200 focus:border-charcoal-700 focus:outline-none py-2 text-lg"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <label className="text-[0.65rem] tracking-[0.25em] uppercase text-charcoal-500">Password</label>
              <input
                type="password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="w-full bg-transparent border-0 border-b-2 border-cream-200 focus:border-charcoal-700 focus:outline-none py-2 text-lg"
                placeholder="••••••••"
              />
            </div>
            <button type="submit" disabled={loading} data-testid="login-submit-button" className="btn-primary-pill w-full disabled:opacity-60">
              {loading ? "Signing in…" : "Sign in"}
              <ArrowRight className="ml-2" size={16} />
            </button>
          </form>
          <p className="mt-8 text-sm text-charcoal-600">
            New here? <Link to="/register" data-testid="go-register" className="text-charcoal-900 underline">Create an account</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
